import styled from 'styled-components';
import {mobileMedia} from '../../../../globalVariables/GlobalVariables';
import {getPrimitive, getSpacing, getFontWeight, getFontSize, getToken} from '@tickchak/react-share/app';
import {dFlexColumn, dFlexCenter} from '../../../../globalVariables/GlobalFlex';

export const statCard = styled.div`
    ${dFlexColumn};
    ${dFlexCenter};
    gap: 8px;
    padding: ${getSpacing('spaceLg')};
    border-radius: 5px;
    border: 1px solid ${getPrimitive('turquoise.turquoise500')};
    background: ${getPrimitive('turquoise.turquoise100')};
    width: 100%;
    ${mobileMedia} {
        padding: ${getSpacing('spaceMd')};
    }
`;

export const value = styled.div`
    font-weight: ${getFontWeight('bold')};
    font-size: ${getFontSize('h2')};
    color: ${getToken('color.text.default')};
    letter-spacing: -0.24px;
    text-align: center;
`;

export const label = styled.div`
    color: ${getToken('color.text.default')};
`;

export const additionalInfo = styled.div`
    font-size: ${getFontSize('caption')};
    color: ${getToken('color.text.secondary')};
    line-height: ${getToken('typography.lineHeight.caption')};
    margin-top: ${getSpacing('spaceXs')};
`;

